<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" md="6" class="offset-md-3">
          <div class="pa-2 rounded elevation-1 bg-white">
            <div class="d-flex flex-start">
              <router-link class="sm-fullwidth" :to="{ name: 'Home' }">
                <v-btn color="primary-dark" block class="sm-fullwidth mt-2" variant="default" size="small"> <v-icon
                    icon="mdi-arrow-left-bold"></v-icon> Retour à l'accueil </v-btn>
              </router-link>
            </div>
            <div v-if="!email_sent">
              <div class="text-h5 mt-3 mb-2">Mot de passe oublié</div>

              <div class="text-body mb-4">Veuillez saisir votre adresse email pour recevoir un lien de réinitialisation
                de votre mot de passe.</div>
              <v-form ref="reset_pass_form" v-model="reset_pass_form_valid">
                <label class="field_label">Email</label>
                <v-text-field v-model="email" ref="field_email" @blur="$refs.field_email.validate()" required
                  :rules="[$formRules.email(email)]"></v-text-field>

                <v-alert color="dark-red" variant="tonal" density="compact" class="mb-2" v-if="errors" type="error">{{
                  errors }}</v-alert>
                <v-btn color="primary-dark" block class="mt-2" @click="sendResetEmail()">Envoyer</v-btn>
              </v-form>
            </div>
            <div v-else>
              <div class="text-h5 mt-3 mb-2">Email de récupération envoyé</div>
              <div class="text-body mb-4">Un email de changement de mot de passe vous a été envoyé à l'adresse {{ email
                }}. Veuillez suivre les instructions présentes dans ce mail.</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserAuthService from "@/services/user-auth.service.js";
export default {
  data() {
    return {
      email_sent: false,
      errors: "",
      reset_pass_form_valid: false,
      email: "",
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async sendResetEmail() {
      const { valid } = await this.$refs.reset_pass_form.validate();
      if (!valid) {
        this.errors = "Veuillez corriger les erreurs dans le formulaire";
        return;
      }
      const base_module = this.mainStore.module.base;
      let request = await UserAuthService.sendResetPassEmail(this.email, base_module);
      if (request.success) {
        this.email_sent = true;
      } else {
        this.errors = request.error;
      }
    },
  },
  async created() { },
};
</script>

<style lang="scss" scoped></style>